import { render, staticRenderFns } from "./DnDisciplineEvaluation.vue?vue&type=template&id=b0343816&scoped=true&"
import script from "./DnDisciplineEvaluation.vue?vue&type=script&lang=js&"
export * from "./DnDisciplineEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./DnDisciplineEvaluation.vue?vue&type=style&index=0&id=b0343816&lang=scss&scoped=true&"
import style1 from "./DnDisciplineEvaluation.vue?vue&type=style&index=1&id=b0343816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0343816",
  null
  
)

export default component.exports